import { FinanceResponse } from '@upstart/harmony/lib/legos/financingTypes';
import BackendService from './BackendService';

export default class FinanceResponseService {
  static getForApplications(applicationIds: string[]) {
    return BackendService.post('/financeResponses', {
      body: { applicationIds },
    });
  }

  static get(id: string, params: any): Promise<FinanceResponse> {
    return BackendService.get(`/financeResponses/${id}`, { params });
  }

  static update(financeResponse: FinanceResponse) {
    return BackendService.put(`/financeResponses/${financeResponse.id}`, {
      body: financeResponse,
    });
  }

  static reviewFinancing(financeResponse: FinanceResponse) {
    return BackendService.put(
      `/financeResponses/${financeResponse.id}/finance-review`,
      {
        body: financeResponse,
      },
    );
  }

  static async cloneUpstartFinanceResponse(financeResponseId: string) {
    return BackendService.post(`/financeResponses/${financeResponseId}/clone`);
  }
  static getAudit(id: string) {
    return BackendService.get(`/financeResponses/audit/${id}`);
  }
  static getRates(id: string) {
    return BackendService.get(`/financeResponses/${id}/rates`);
  }
}
